import BookGroup from "components/BookGroup";
import { BookGroupSizeType } from "components/BookGroup/types";
import BookGroupListItem from "components/BookGroup/items/BookGroupListItem";
import BookListHeader from "components/BookGroup/headers/BookListHeader";
import { BookSerializersBookByline, ListSerializersListGroup } from "types/serializers";

export default function BookListGroup({
  list,
  activeBook,
  size,
  className,
}: {
  activeBook?: BookSerializersBookByline;
  list: ListSerializersListGroup
  size: BookGroupSizeType;
  className?: string;
}) {
  const books = list.listBooks.map((lb) => lb.book);

  return (
    <BookGroup
      size={size}
      books={size === "lg" ? books : books.slice(0, 7)}
      className={className}
      HeaderComponent={BookListHeader}
      ItemComponent={BookGroupListItem}
      context={{
        list,
        activeBook,
        referrerId: list.userId,
      }}
    />
  );
}
